import {
  createIdentifier,
  type IdentifierCode,
  valsOrNone,
} from '@quromedical/fhir-common';
import { compact } from '@quromedical/utils';
import type { Identifier } from 'fhir/r4';

interface WithIdentifier {
  identifier?: Identifier[];
}

/**
 * Create an identifier optionally based on whether or not the value is defined
 */
export const createOptionalIdentifier = (
  code: IdentifierCode,
  value?: string,
): Identifier | undefined => {
  if (!value) {
    return undefined;
  }

  return createIdentifier(code, value);
};

export const attachIdentifiers = <TResource extends WithIdentifier>(
  resource: TResource,
  ...identifiers: (Identifier | undefined)[]
): TResource => {
  const identifier = [...(resource.identifier || []), ...compact(identifiers)];

  return {
    ...resource,
    identifier: valsOrNone(identifier),
  };
};
